import { reactive } from "vue";

export type LoadingStateObserverData = { value: boolean };

class LoadingStateChangeObserver {
    data: LoadingStateObserverData;
    constructor() {
        this.data = reactive({ value: false });
    }

    fire(value: boolean) {
        this.data.value = value;
    }
}

const observerMap: { el: HTMLElement; observer: LoadingStateChangeObserver }[] =
    [];

export function getObserver(formEl: HTMLElement) {
    return getObserverAndForm(formEl)?.observer;
}

export function getObserverAndForm(formEl: HTMLElement) {
    let form: HTMLElement | null = formEl;

    while (
        form.classList != null &&
        form.classList.contains("product-list-filter-form") !== true
    ) {
        form = form.parentElement;
        if (form == null) throw new Error("did not find form");
    }

    return (
        observerMap.find((x) => x.el === form) ?? {
            el: form,
            observer: undefined as undefined | LoadingStateChangeObserver,
        }
    );
}

export function getOrCreateObserver(formEl: HTMLElement) {
    const match = getObserverAndForm(formEl);

    if (match.observer == null) {
        match.observer = new LoadingStateChangeObserver();
        observerMap.push(match as (typeof observerMap)[number]);
    }
    return match.observer;
}

export function getOrCreateObserverData(
    formEl: HTMLElement
) {
    return getOrCreateObserver(formEl).data;
}
